import _memoize from 'lodash/memoize';
export type RGBColor = {
  r: number;
  g: number;
  b: number;
  a?: number | undefined;
};

export enum ColorFormat {
  string = 'string',
  object = 'object',
}

function hexToRGB(
  hex: string,
  opacity?: number,
  format?: ColorFormat.string,
): string;
function hexToRGB(
  hex: string,
  opacity: number,
  format: ColorFormat.object,
): RGBColor;

function hexToRGB(
  hex: string,
  opacity = 1,
  format = ColorFormat.string,
): string | RGBColor | null {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) {
    return null;
  }
  switch (format) {
    case ColorFormat.object:
      return {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
        a: opacity,
      };
    case ColorFormat.string:
    default:
      return `rgba(${parseInt(result[1], 16)},${parseInt(
        result[2],
        16,
      )}, ${parseInt(result[3], 16)}, ${opacity})`;
  }
}

// this function might be run a lot of times on web so we wanna make sure to keep it memoized
const resolver = (...args: unknown[]) => JSON.stringify(args);

export default _memoize(hexToRGB, resolver);

// SAMPLE USAGE
// hexToRGB(colors.white) => "rgba(255,255,255, 1)"
// hexToRGB(colors.white, 0.6) => "rgba(255,255,255, 0.6)"
// hexToRGB(colors.white, 0.6, "object") => {
//   r: 255,
//   g: 255,
//   b: 255,
//   a: 0.6,
// }
